import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC, MouseEvent } from "react"

interface WarehouseShelvingRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isOpen: boolean
  onEdit: (e: MouseEvent<HTMLLIElement>) => void
}

const WarehouseShelvingRowDropdownMenu: FC<WarehouseShelvingRowDropdownMenuProps> = ({
  anchorEl,
  onClose,
  isOpen,
  onEdit,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose} data-test='warehouse-shelving-row-dropdown-menu'>
      <MenuItem onClick={onEdit} data-test='warehouse-shelving-edit-menu-item'>
        <ListItemIcon>
          <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Edit' />
      </MenuItem>
    </Menu>
  )
}

export default WarehouseShelvingRowDropdownMenu
